import { useState, useEffect, DependencyList, useContext } from 'react';
import { NotificationFunctionContext } from '../components/notifications/notificationProvider';
import { RenderPageNotFoundContext } from '../pages/pagenotfoundStore';

export interface Loader<T> {
  data?: T;
  loading: boolean;
  error?: Error;
  reload(): void;
}

// TODO Attempt to resolve eslint-disable issue
/* eslint-disable react-hooks/exhaustive-deps */

export const useLoader = <T extends unknown>(
  loaderFunction: () => Promise<T>,
  deps: DependencyList = [],
  notify: boolean = true, // If errors should trigger a user notification
  pageNotFoundRedirect?: boolean, // If errors should redirect to 404-page
): Loader<T> => {
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<Error | undefined>();
  const [data, setData] = useState<T | undefined>();

  const { addErrorNotification } = useContext(NotificationFunctionContext);
  const { renderPageNotFound, shouldRender: isRenderingPageNotFound } =
    useContext(RenderPageNotFoundContext);

  const reload = () => {
    setLoading(true);
    setError(undefined);
    setData(undefined);

    if (isRenderingPageNotFound) return;

    loaderFunction()
      .then((value) => setData(value))
      .catch((err) => {
        setError(err);

        if (notify) {
          addErrorNotification(err.body);
        }

        if (pageNotFoundRedirect) {
          renderPageNotFound(true);
        }
      })
      .finally(() => setLoading(false));
  };

  useEffect(reload, [...deps]);

  return { data, loading, error, reload };
};
